<template>
	<div class="layout">
		<div class="center">
			<div class="menu">
				<Menu></Menu>
			</div>
			<div class="content">
				<router-view :key="fullPath"></router-view>
			</div>
		</div>

	</div>

</template>

<script>
	import Menu from "./Menu.vue";
	export default {
		name: 'WorkBenchLayout',
		components: {
			Menu
		},
		data() {
			return {
				fullPath:''
			};
		},
		watch:{
			'$route':{
				handler(news){
					console.log('fullPath--',news);
					this.fullPath = news.fullPath;
					console.log('this---full',this.fullPath);
				},
				// immediate:true,
				deep:true
			}
		},
		beforeRouteEnter(to, from, next) {
			next((vm) => {
			// 通过 `vm` 访问组件实例
			vm.$emit("changeFooter", 'light');
			});
		},	
		mounted(){
			// this.$parent.foot_style="light";
		},
		methods: {

		}
	}
</script>

<style lang="scss" scoped>
	.layout {
		background: #F6F7FA;
		// overflow: auto;
		// height:100vh;
		display:flex;
		flex-direction: column;
		.center{
			display: flex;
			flex:1;
			.menu{
				// flex: 1;
				width:350px;
			}
			.content {
				background: white;
				padding-bottom:80px;
				flex:1;
				overflow:auto;
			}
		}
	}

	@media (max-width:1280px) and (max-width:1679px){
		.layout {
			// overflow:auto;
			width:1280px !important;
			min-width:1280px !important;
			max-width:1679px !important;
			flex:1;
			display:flex;
			flex-direction: column;
			.center{
				display: flex;
				flex:1;
				.menu{
					// width:280px;
				}
				.content{
					flex: 1;
					background: white;
					// width:100%;
				}
			}

			// .content {
			// 	background: white;
			// }
		}
	}

	@media (max-width:1279px){
		.layout {
			// overflow:auto;
			max-width:1279px;
			width:1279px !important;
			display:flex;
			flex-direction: column;
			.center{
				display: flex;
				flex:1;
				.menu{
					// width:280px;
				}
				.content{
					flex: 1;
					background: white;
					// width:100%;
				}
			}

			// .content {
			// 	background: white;
			// }
		}
	}
</style>
